export const navigation: any = [
    {
        'id'      : 'pages',
        'title'   : 'Pages',
        'translate': 'NAV.PAGES',
        'type'    : 'group',
        'children': [
            {
                'id'   : 'dashboard',
                'title': 'Dashboard',
                'translate': 'NAV.DASHBOARD.TITLE',
                'type' : 'item',
                'icon' : 'dashboard',
                'url'  : '/',
                'exactMatch': true,
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            },
            {
                'id'   : 'calendar',
                'title': 'Calendar',
                'translate': 'NAV.CALENDAR.TITLE',
                'type' : 'item',
                'icon' : 'today',
                'url'  : '/calendar',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            },
            {
                'id'   : 'leads',
                'title': 'Leads',
                'translate': 'NAV.LEADS.TITLE',
                'type' : 'collapse',
                'icon' : 'storage',
                'permission': 'global_view_leads',
                'children' : [
                    {
                        'id'   : 'leads-individual',
                        'title': 'leads individual',
                        'translate': 'NAV.LEADS_INDIVIDUAL.TITLE',
                        'type' : 'item',
                        'url'  : '/leads',
                        'badge'    : {
                            'title'    : 0,
                            'translate': 'NAV.MAIL.BADGE',
                            'bg'       : '#F44336',
                            'fg'       : '#FFFFFF'
                        }
                    },
                    {
                        'id'   : 'leads-legal',
                        'title': 'leads-legal',
                        'translate': 'NAV.LEADS_LEGAL.TITLE',
                        'type' : 'item',
                        'url'  : '/leads-legal',
                        'badge'    : {
                            'title'    : 0,
                            'translate': 'NAV.MAIL.BADGE',
                            'bg'       : '#F44336',
                            'fg'       : '#FFFFFF'
                        }
                    }
                ]
            },
            {
                'id'   : 'clients',
                'title': 'Clients',
                'translate': 'NAV.CLIENTS.TITLE',
                'type' : 'collapse',
                'icon' : 'group',
                'permission': 'global_view_clients',
                'children' : [
                    {
                        'id'   : 'clients-individual',
                        'title': 'clients individual',
                        'translate': 'NAV.CLIENTS_INDIVIDUAL.TITLE',
                        'type' : 'item',
                        'url'  : '/clients',
                        'badge'    : {
                            'title'    : 0,
                            'translate': 'NAV.MAIL.BADGE',
                            'bg'       : '#F44336',
                            'fg'       : '#FFFFFF'
                        }
                    },
                    {
                        'id'   : 'clients-legal',
                        'title': 'clients-legal',
                        'translate': 'NAV.CLIENTS_LEGAL.TITLE',
                        'type' : 'item',
                        'url'  : '/clients-legal',
                        'badge'    : {
                            'title'    : 0,
                            'translate': 'NAV.MAIL.BADGE',
                            'bg'       : '#F44336',
                            'fg'       : '#FFFFFF'
                        }
                    }
                ]
            },
            {
                'id'   : 'tickets',
                'title': 'Tickets',
                'translate': 'NAV.TICKETS.TITLE',
                'type' : 'item',
                'icon' : 'description',
                'url'  : '/tickets',
                'permission': 'view_common_other_tickets',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            },
            {
                'id'   : 'copytrading',
                'title': 'Copytrading',
                'translate': 'NAV.COPYTRADING.TITLE',
                'type' : 'item',
                'icon' : 'file_copy',
                'url'  : '/copytrading',
                'permission': 'view_common_other_copytrading',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            },
            {
                'id'   : 'address-book',
                'title': 'Address book',
                'translate': 'NAV.ADDRESS_BOOK.TITLE',
                'type' : 'item',
                'icon' : 'contact_phone',
                'url'  : '/address-book',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            }
        ]
    },
    // {
    //     'id'   : 'emails',
    //     'title': 'Emails',
    //     'translate': 'NAV.EMAILS.TITLE',
    //     'type' : 'collapse',
    //     'icon' : 'email',
    //     'children': [
    //         {
    //             'id'   : 'bulk-emails',
    //             'title': 'Bulk Emails',
    //             'translate': 'NAV.EMAIL_RULES.TITLE',
    //             'type' : 'item',
    //             'icon' : 'contact_mail',
    //             'url'  : '/bulk-emails',
    //             'badge'    : {
    //                 'title'    : 0,
    //                 'translate': 'NAV.EMAIL_RULES.BADGE',
    //                 'bg'       : '#F44336',
    //                 'fg'       : '#FFFFFF'
    //             }
    //         },
    //         {
    //             'id'   : 'mailing-templates',
    //             'title': 'Mailing templates',
    //             'translate': 'NAV.EMAIL_TEMPLATES.TITLE',
    //             'type' : 'item',
    //             'icon' : 'picture_in_picture',
    //             'url'  : '/mailing-templates',
    //             'badge'    : {
    //                 'title'    : 0,
    //                 'translate': 'NAV.EMAIL_TEMPLATES.BADGE',
    //                 'bg'       : '#F44336',
    //                 'fg'       : '#FFFFFF'
    //             }
    //         },
    //         {
    //             'id'   : 'user-selections',
    //             'title': 'User selections',
    //             'translate': 'NAV.USER_SELECTIONS.TITLE',
    //             'type' : 'item',
    //             'icon' : 'people',
    //             'url'  : '/user-selections',
    //             'badge'    : {
    //                 'title'    : 0,
    //                 'translate': 'NAV.USER_SELECTIONS.BADGE',
    //                 'bg'       : '#F44336',
    //                 'fg'       : '#FFFFFF'
    //             }
    //         },
    //     ]
    // },
    {
        'id'      : 'custom-function',
        'title'   : 'Custom Function',
        'translate': 'NAV.CUSTOM_FUNCTIONS.TITLE',
        'type'    : 'group',
        'children': [
            {
                'id'   : 'profile',
                'title': 'Profile',
                'translate': 'NAV.PROFILE.TITLE',
                'type' : 'item',
                'icon' : 'account_box',
                'url'  : '/profile',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            },
            {
                'id'   : 'settings',
                'title': 'Settings',
                'translate': 'NAV.SETTINGS.TITLE',
                'type' : 'item',
                'icon' : 'settings_applications',
                'url'  : '/settings',
                'permission': 'view_common_other_employees',
                'badge'    : {
                    'title'    : 0,
                    'translate': 'NAV.MAIL.BADGE',
                    'bg'       : '#F44336',
                    'fg'       : '#FFFFFF'
                }
            }
        ]
    }
    
];



// WEBPACK FOOTER //
// ./src/app/navigation/navigation.ts